<template>
  <div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          Съединението
        </div>
      </div>
      <div class="info-box-content">
        прави силата
      </div>
    </div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          Обединението
        </div>
      </div>
      <div class="info-box-content">
        изгражда нация
      </div>
    </div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          Народът
        </div>
      </div>
      <div class="info-box-content">
        прави държавата
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "september6th-slogan-component"
}
</script>

<style scoped>
.info-box {
  width: 350px;
}

.info-box-title {
  flex-basis: 170px;
  height: 80px;
  font-size: 1rem;
  text-transform: uppercase;
}
</style>
